export default "__VITE_ASSET__9VYtY6v7unzzTZbBqcLtSQ__"